function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "icon-warning"
}, "Warning Icon-");

var SvgIconWarning = function SvgIconWarning(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "aria-labelledby": "icon-warning",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "icon-warning"
  }, title) : null, React.createElement("path", {
    d: "M40,32.94a1,1,0,0,0-1,1v8.85a1,1,0,0,0,2-.12V33.82A1,1,0,0,0,40,32.94ZM40,45.8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,40,45.8Zm1-18.48a2,2,0,0,1,.78.78L53.86,50a2,2,0,0,1-.78,2.72,2.06,2.06,0,0,1-1,.25H27.89a2,2,0,0,1-2-2,2,2,0,0,1,.25-1L38.25,28.1A2,2,0,0,1,41,27.32Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconWarning, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-warning.4b94c9c3.svg";
export { ForwardRef as ReactComponent };